// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"61ee072d","780":"0889ee50"}[chunkId] + ".chunk.css";
};